<template>
  <b-container class="mt-5 mb-5">
    <!-- ДЕСКТОПНАЯ ВЕРСИЯ -->
    <div class="d-none d-md-block">
      <b-table striped hover :items="items" :fields="fields" responsive="sm">
        <template #cell(ts)="data">
          {{ new Date(data.item.ts).toLocaleDateString('en-GB') }}
        </template>

        <template #cell(nextPaymentTs)="data">
          <span v-if="isUnlimited(data.item)" class="text-success">Бессрочный тариф</span>
          <span v-else-if="data.item.nextPaymentTs">
             {{ new Date(data.item.nextPaymentTs).toLocaleDateString('en-GB') }}
          </span>
          <span v-else>-- -- --</span>
        </template>

        <template #cell(cancelTs)="row">
          <b-button
              size="sm"
              class="mr-2"
              variant="secondary"
              disabled
              v-if="items[row.index].cancelTs"
          >
            Подписка отменена
          </b-button>
          <!-- Кнопка только если не бессрочная и не отменена -->
          <b-button
              size="sm"
              class="mr-2"
              variant="success"
              v-on:click="unSubscribe(row)"
              v-else-if="!isUnlimited(items[row.index])"
          >
            Отменить подписку
          </b-button>
          <span v-else class="text-muted font-italic d-block text-center">Управление недоступно</span>
        </template>

        <template #cell(idStoreId)="data">
          {{ data.item.id }}/{{ data.item.storeId }}
        </template>
      </b-table>
    </div>

    <!-- МОБИЛЬНАЯ ВЕРСИЯ -->
    <div v-for="(item, index) in items" :key="index" class="d-md-none mb-3 border-0 rounded-lg bg-white mobile-shadow overflow-hidden">
      <div
          class="p-3"
          style="cursor: pointer;"
          @click="toggleCollapse(index)"
      >
        <div class="d-flex justify-content-between align-items-start mb-2">
          <h6 class="mb-0 font-weight-bold text-dark pr-2">{{ item.descr }}</h6>
          <div :class="['status-pill', item.cancelTs ? 'status-off' : 'status-on']" style="white-space: nowrap;">
            {{ item.cancelTs ? 'ОТМЕНЕНА' : 'АКТИВНА' }}
          </div>
        </div>

        <div class="small text-muted mb-2">
          <span class="bg-light border rounded px-1">ID: {{ item.id }}/{{ item.storeId }}</span>
        </div>

        <div class="d-flex justify-content-between align-items-end mt-1">
          <div class="small">
            <span v-if="item.cancelTs" class="text-muted opacity-75">
              <b-icon icon="x-circle" class="mr-1"></b-icon>Подписка отменена
            </span>
            <span v-else-if="isUnlimited(item)" class="text-success font-weight-bold">
              <b-icon icon="infinity" class="mr-1"></b-icon>Бессрочный тариф
            </span>
            <span v-else-if="item.nextPaymentTs" class="text-dark">
              <b-icon icon="calendar2-check" class="mr-1 text-primary"></b-icon>
              Списание: <b>{{ new Date(item.nextPaymentTs).toLocaleDateString('en-GB') }}</b>
            </span>
          </div>

          <b-icon :icon="openedItems[index] ? 'chevron-up' : 'chevron-down'" class="text-muted ml-2"></b-icon>
        </div>
      </div>

      <b-collapse :visible="!!openedItems[index]">
        <div class="p-3 border-top" style="background-color: #fcfcfc;">
          <div class="mb-2 d-flex justify-content-between">
            <span class="text-muted small">Дата подключения:</span>
            <span class="small font-weight-bold">{{ new Date(item.ts).toLocaleDateString('en-GB') }}</span>
          </div>
          <div class="mb-3 d-flex justify-content-between">
            <span class="text-muted small">Стоимость:</span>
            <span class="small font-weight-bold text-primary">{{ item.price }} RUB</span>
          </div>

          <!-- Скрываем кнопку для бессрочных тарифов -->
          <div v-if="!isUnlimited(item)">
            <b-button
                v-if="!item.cancelTs"
                size="md"
                variant="success"
                v-on:click="unSubscribeMobile(index)"
                block
                class="font-weight-bold py-2"
                style="background-color: #198754; border: none;"
            >
              Отменить подписку
            </b-button>
            <b-button v-else size="md" variant="secondary" disabled block class="opacity-50">
              Подписка отменена
            </b-button>
          </div>
        </div>
      </b-collapse>
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        { key: 'idStoreId', label: 'ID' },
        { key: 'ts', label: 'Дата подключения' },
        { key: 'nextPaymentTs', label: 'Дата следующего списания' },
        { key: 'descr', label: 'Название подписки' },
        { key: 'price', label: 'Стоимость продления (RUB)' },
        { key: 'cancelTs', label: 'Действия' }
      ],
      items: [],
      openedItems: {}
    }
  },
  created() {
    this.loadSubscribe();
  },
  methods: {

    isUnlimited(item) {
      if (item.unlimited !== undefined) return item.unlimited; // на будущее
      return !item.nextPaymentTs && !item.cancelTs;
    },

    loadSubscribe() {
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      this.$http.post(`${process.env.VUE_APP_API_URL}/subscription/all/`, {}).then(response => {
        if (response.status === 200) {
          this.items = response.data.list;
        }
      }).catch(() => {
        localStorage.removeItem('jwt');
        this.$router.push({ name: 'login' });
      });
    },
    toggleCollapse(index) {
      this.$set(this.openedItems, index, !this.openedItems[index]);
    },
    unSubscribe(row) {
      if (confirm("Вы действительно хотите отменить подписку?")) {
        this.executeUnsubscribe(this.items[row.index], row.index);
      }
    },
    unSubscribeMobile(index) {
      if (confirm("Вы действительно хотите отменить подписку?")) {
        this.executeUnsubscribe(this.items[index], index);
      }
    },
    executeUnsubscribe(item, index) {
      this.$http.post(`${process.env.VUE_APP_API_URL}/subscription/cancel/`, {
        id: item.id,
        storeId: item.storeId
      }).then(response => {
        if (response.status === 200) {
          this.$set(this.items[index], 'cancelTs', Math.round(+new Date() / 1000));
        }
      }).catch(() => {
        this.$router.push({ name: 'login' });
      });
    }
  }
}
</script>

<style scoped>
.font-weight-bold { font-weight: 600; }
.rounded-lg { border-radius: 12px !important; }

.mobile-shadow {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.status-pill {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.status-on {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}
.status-off {
  background-color: #f5f5f5;
  color: #757575;
  border: 1px solid #e0e0e0;
}
</style>